export default function AboutOfficeSection() {
  return (
    <section id="about" className="bg-[#080C14] py-24">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        {/* Section Header */}
        <div className="mb-14">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-8 h-[2px] bg-[#C9A84C]"></div>
            <span className="text-[#C9A84C] text-xs font-semibold tracking-[0.3em] uppercase">О компании · Штаб-квартира</span>
          </div>
          <h2 className="text-white mb-5" style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: "clamp(36px, 5vw, 64px)", letterSpacing: "0.03em" }}>
            ШТАБ-КВАРТИРА YAXIN:<br />
            <span className="text-[#C9A84C]">БАШНЯ ЦЗИНЬЯО</span> · ХАНЧЖОУ
          </h2>
          <p className="text-gray-400 text-lg max-w-3xl leading-relaxed">
            Главный офис: бизнес-центр Jinyao Tower, г. Ханчжоу — один из крупнейших деловых центров Китая. Здесь работает команда специалистов по экспорту, логистике и сертификации, обеспечивающая бесперебойные поставки в Россию.
          </p>
        </div>

        {/* Main Photo Layout */}
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-4 mb-14">
          {/* Left: Jingyao Building Render — large */}
          <div className="lg:col-span-3 relative overflow-hidden rounded-sm" style={{ height: "520px" }}>
            <img
              src="https://static.readdy.ai/image/8c03a4ff3aff362c6a853342ebc1a3dd/87a55b81640e81d1c8d3a12d9b5f7486.jpeg"
              alt="Hangzhou YAXIN headquarters Jingyao Tower — Shell HK distributor China export"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#080C14]/80 via-transparent to-transparent"></div>
            <div className="absolute bottom-6 left-6 right-6">
              <div className="text-[#C9A84C] text-[10px] font-semibold tracking-[0.25em] uppercase mb-2">Ханчжоу · Башня Цзиньяо</div>
              <div className="text-white font-black text-xl" style={{ fontFamily: "'Bebas Neue', sans-serif", letterSpacing: "0.04em" }}>
                ГОЛОВНОЙ ОФИС YAXIN LIANPEI
              </div>
              <div className="text-gray-300 text-sm mt-1">19-й этаж · Деловой центр Ханчжоу</div>
            </div>
          </div>

          {/* Right: Office photos stacked */}
          <div className="lg:col-span-2 flex flex-col gap-4">
            <div className="relative overflow-hidden rounded-sm flex-1" style={{ minHeight: "248px" }}>
              <img
                src="https://storage.readdy-site.link/project_files/9f45cb21-4b77-4979-b082-2610d4bf0c89/e80c64c2-1f89-467a-8422-ed28bd5662cf__20260409214146_9_101.jpg?v=0564cec21fc5bea770139363f89bf2f4"
                alt="YAXIN LIANPEI office team Hangzhou — Guangzhou Chirun logistics hub"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#080C14]/70 via-transparent to-transparent"></div>
              <div className="absolute bottom-4 left-4">
                <div className="text-[#C9A84C] text-[10px] font-semibold tracking-[0.2em] uppercase mb-1">Рабочее пространство</div>
                <div className="text-white text-sm font-bold">Офис 19F · Команда экспорта</div>
              </div>
            </div>
            <div className="relative overflow-hidden rounded-sm flex-1" style={{ minHeight: "248px" }}>
              <img
                src="https://storage.readdy-site.link/project_files/9f45cb21-4b77-4979-b082-2610d4bf0c89/f4ecb283-25de-4a11-9ceb-fc15b5c4448c__20260409214201_10_101.jpg?v=34e09fd8aafe2e2c08704c4a9c5e703f"
                alt="YAXIN LIANPEI office interior Hangzhou — Shell HK distributor workspace"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#080C14]/70 via-transparent to-transparent"></div>
              <div className="absolute bottom-4 left-4">
                <div className="text-[#C9A84C] text-[10px] font-semibold tracking-[0.2em] uppercase mb-1">Операционный центр</div>
                <div className="text-white text-sm font-bold">Логистика и сертификация</div>
              </div>
            </div>
          </div>
        </div>

        {/* 3-Entity Architecture */}
        <div className="mb-14">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-8 h-[2px] bg-[#C9A84C]"></div>
            <span className="text-[#C9A84C] text-xs font-semibold tracking-[0.3em] uppercase">Архитектура замкнутого цикла</span>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-0">
            {[
              {
                name: "YAXIN LIANPEI",
                location: "КНР · Ханчжоу (Главный офис)",
                role: "Операции и Проценка",
                desc: "Главный офис: бизнес-центр Jinyao Tower, г. Ханчжоу. Формирование ассортимента, строгий аудит качества, технический анализ баз данных и расчет предельно низких оптовых B2B-цен.",
                icon: "ri-building-2-line",
                num: "01",
              },
              {
                name: "GUANGZHOU CHIRUN",
                location: "КНР · Гуанчжоу",
                role: "Экспорт и Логистика",
                desc: "Специализируется исключительно на экспортном таможенном оформлении в КНР и организации точной координации международных логистических маршрутов.",
                icon: "ri-ship-line",
                num: "02",
              },
              {
                name: "ООО «ЯСИН РУС»",
                location: "Россия · Москва",
                role: "Легализация и Финансы",
                desc: "Официальная «белая» таможенная очистка на всей территории РФ. Статус официального заявителя EAC. Уплата налогов и легальный финансовый учёт в рублях.",
                icon: "ri-government-line",
                num: "03",
              },
            ].map((entity, idx) => (
              <div key={entity.name} className="relative">
                <div className="bg-[#0D1420] border border-[#1E2A3A] p-8 h-full hover:border-[#C9A84C]/40 transition-colors duration-300">
                  <div className="text-[#C9A84C]/20 font-black mb-4" style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: "72px", lineHeight: 1 }}>
                    {entity.num}
                  </div>
                  <div className="w-12 h-12 flex items-center justify-center border border-[#C9A84C]/30 rounded-sm mb-4">
                    <i className={`${entity.icon} text-[#C9A84C] text-xl`}></i>
                  </div>
                  <div className="text-[#C9A84C] text-xs font-semibold tracking-[0.2em] uppercase mb-1">{entity.location}</div>
                  <h3 className="text-white font-bold text-lg mb-1" style={{ fontFamily: "'Oswald', sans-serif" }}>{entity.name}</h3>
                  <div className="text-gray-400 text-sm font-medium mb-4 uppercase tracking-wide">{entity.role}</div>
                  <p className="text-gray-500 text-sm leading-relaxed">{entity.desc}</p>
                </div>
                {idx < 2 && (
                  <div className="hidden md:flex absolute top-1/2 -right-4 -translate-y-1/2 z-10 w-8 h-8 items-center justify-center bg-[#C9A84C] rounded-full">
                    <i className="ri-arrow-right-line text-[#0A0F1A] text-sm font-bold"></i>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Two Legalization Models */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="bg-[#0D1420] border border-[#C9A84C]/30 p-8 rounded-sm">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-[#C9A84C] rounded-sm">
                <span className="text-[#0A0F1A] font-black text-sm">1</span>
              </div>
              <h3 className="text-white font-bold text-lg" style={{ fontFamily: "'Oswald', sans-serif" }}>Модель 1 — Стандартный выпуск</h3>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-4">
              Для покупателей нашего ассортимента. Импортером и держателем сертификатов EAC выступает <strong className="text-white">ООО «ЯСИН РУС»</strong>. Вы получаете готовый к продаже товар с нанесёнными кодами <strong className="text-[#C9A84C]">«Честный ЗНАК»</strong>.
            </p>
            <div className="flex items-center gap-2 text-[#C9A84C] text-sm font-semibold">
              <i className="ri-shield-check-line"></i>
              Никаких рисков на таможне
            </div>
          </div>
          <div className="bg-[#0D1420] border border-[#1E2A3A] p-8 rounded-sm hover:border-[#C9A84C]/30 transition-colors">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-[#1E2A3A] border border-[#C9A84C]/40 rounded-sm">
                <span className="text-[#C9A84C] font-black text-sm">2</span>
              </div>
              <h3 className="text-white font-bold text-lg" style={{ fontFamily: "'Oswald', sans-serif" }}>Модель 2 — Агентская сертификация</h3>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-4">
              Для вашего собственного бренда. ООО «ЯСИН РУС» выступит официальным Заявителем. Мы пройдём испытания, выпустим <strong className="text-white">EAC на ваше имя</strong> и наклеим «Честный ЗНАК» в Гуанчжоу/Нинбо перед экспортом.
            </p>
            <div className="flex items-center gap-2 text-gray-400 text-sm font-semibold">
              <i className="ri-award-line text-[#C9A84C]"></i>
              EAC под вашим брендом
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
